import { columnSetActionTypes } from "../Constants/ActionTypes";

export const toggleCreateColumnSet = (dispatch, payload) => {
  dispatch({
    type: columnSetActionTypes.TOGGLE_CREATE_COLUMN_SET,
    payload: payload,
  });
};

export const setBreakdownColumnSetData = (dispatch, payload) => {
  dispatch({
    type: columnSetActionTypes.SET_BREAKDOWN_COLUMN_SET_DATA,
    payload: payload,
  });
};

export const setColumnSetStatusData = (dispatch, payload) => {
  dispatch({
    type: columnSetActionTypes.COLUMN_SET_STATUS_DATA,
    payload: payload,
  });
};
